"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logWarning = exports.logProduction = exports.logError = exports.logDebug = exports.log = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 *  Copyright AlpineReplay Inc, 2023. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * This is a logging utility that allows us to log messages to the console
 * This will only log in developemnt and test environments
 * @param tag - a tag to identify the log message
 * @param msgs - the messages to log
 * @returns {void}
 **/
var log = function log(tag) {
  for (var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    msgs[_key - 1] = arguments[_key];
  }

  doLog(tag, msgs, null, "LOG", ["development", "test"]);
};
/**
 * This is a logging utility that allows us to log messages to the console
 * This will log in developemnt, test, and production environments
 * @param tag - a tag to identify the log message
 * @param msgs - the messages to log
 * @returns {void}
 **/


exports.log = log;

var logProduction = function logProduction(tag) {
  for (var _len2 = arguments.length, msgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    msgs[_key2 - 1] = arguments[_key2];
  }

  doLog(tag, msgs, null, "DEBUG", ["development", "test", "production"]);
};
/**
 * This is a logging utility that allows us to debug objects to the console
 * This will log in developemnt environments
 * @param tag - a tag to identify the log message
 * @param msgs - the messages to log
 * @returns {void}
 **/


exports.logProduction = logProduction;

var logDebug = function logDebug(tag) {
  for (var _len3 = arguments.length, objects = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    objects[_key3 - 1] = arguments[_key3];
  }

  doLog(tag, null, objects, "DEBUG", ["development"]);
};
/**
 * This is a logging utility that allows us to log erros to the console
 * This will log in developemnt, test and production environments
 * @param tag - a tag to identify the log message
 * @param msgs - the messages to log
 * @returns {void}
 **/


exports.logDebug = logDebug;

var logError = function logError(msgs) {
  doLog(null, msgs, null, "ERROR", ["development", "test", "production"]);
};
/**
 * This is a logging utility that allows us to log warnings to the console
 * This will log in developemnt, test and production environments
 * @param tag - a tag to identify the log message
 * @param msgs - the messages to log
 * @returns {void}
 **/


exports.logError = logError;

var logWarning = function logWarning(msgs) {
  doLog(null, msgs, null, "WARN", ["development", "test", "production"]);
};

exports.logWarning = logWarning;

var doLog = function doLog(tag, msgs, objects, level, envs) {
  var _console, _console2, _console3, _console4;

  if (envs.includes(process.env.NODE_ENV) === false) {
    console.log("doLog: not logging in this environment", process.env.NODE_ENV, envs);
    return;
  } // find caller


  var e = new Error();
  var stack = e.stack.split("\n");
  var caller = "";

  if (stack && stack.length > 3) {
    var cs = stack[3];
    cs = cs.trim();
    var cp = cs.split(/\s+/);

    if (cp.length >= 2) {
      if (!cp[1].startsWith("http")) {
        caller = cp[1];
      }
    }
  } // get timestamp


  var now = new Date();
  var hr = now.getHours();

  if (hr < 10) {
    hr = "0" + hr;
  }

  var min = now.getMinutes();

  if (min < 10) {
    min = "0" + min;
  }

  var sec = now.getSeconds();

  if (sec < 10) {
    sec = "0" + sec;
  }

  var ms = now.getMilliseconds();

  if (ms < 100) {
    ms = "00" + ms;
  } else if (ms < 10) {
    ms = "0" + ms;
  } // build prefix


  var prefix = "".concat(hr, ":").concat(min, ":").concat(sec, ".").concat(ms);

  if (caller) {
    prefix += " ".concat(caller);
  }

  if (tag) {
    if (caller) {
      prefix += ":";
    } else {
      prefix += " ";
    }

    prefix += "".concat(tag, " ");
  } else {
    prefix += " ";
  }

  switch (level) {
    case "DEBUG":
      console.log(prefix);

      (_console = console).debug.apply(_console, _toConsumableArray(objects));

      break;

    case "ERROR":
      (_console2 = console).error.apply(_console2, [prefix].concat(_toConsumableArray(msgs)));

      break;

    case "WARN":
      (_console3 = console).warn.apply(_console3, [prefix].concat(_toConsumableArray(msgs)));

      break;

    case "LOG":
    default:
      (_console4 = console).log.apply(_console4, [prefix].concat(_toConsumableArray(msgs)));

  }
};